export type ConsentState = {
  marketing_phone_consent: boolean;
  marketing_email_consent: boolean;
};

export const initialConsentState: ConsentState = {
  marketing_phone_consent: false,
  marketing_email_consent: false,
};
